/**
*
* LeaveRequests
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Alert, Button, ListGroup, Card } from 'react-bootstrap';
import webViewMessage from 'containers/WebViewProvider/webViewMessage.js';
import { PARENT_ROLE } from 'containers/User/constants.js';
import { useApi2, useApi2post } from 'containers/Api2/index.js';
import Spinner from 'components/Spinner/index.jsx';
import { idValues } from 'utils/arrays.js';
import { useSearch } from 'utils/urlUtils.js';
import RequestForm from './RequestForm/index.jsx';
import RequestItem from './RequestItem.jsx';
import messages from './messages.js';
import { CAN_EDIT_STATUS } from './constants.js';

function LeaveRequests(props) {
  const { role, studentId, webview } = props;
  const types = useApi2({ url: 'leavereports/types', selector: 'leavereporttypes' });
  const reports = useApi2({ url: studentId && `leavereports/student/${studentId}`, selector: 'leavereports/requests' });
  const [formValues, setFormValues] = useState(null);
  const [expandedItem, setExpandedItem] = useState(null);
  const { studentIds } = useSearch(true);

  const api2post = useApi2post();

  function handleChange(data) {
    return api2post({
      ...data,
      url: 'leavereports',
      selector: 'leavereports/requests',
      withPromise: true,
      noReport: [422],
    });
  }

  function handleClick(item) {
    if (CAN_EDIT_STATUS.includes(item.status)) {
      setFormValues(item);
      setExpandedItem(null);
      return;
    }
    setExpandedItem(expandedItem === item.id ? null : item.id);
  }

  function webviewChange(data) {
    if (!data) {
      return;
    }
    handleChange(data).then((result) => {
      const message = {
        route: 'leaverequest-detail',
        routeArgs: {
          leaveRequestIds: result.list,
        },
      };
      if (window.socsWebViewEmulate) {
      // eslint-disable-next-line no-console
        console.log(message);
      } else {
        webViewMessage(message);
      }
    });
  }

  function renderRequestList() {
    if (!reports || !types) {
      return null;
    }
    if (reports.loading) {
      return <Spinner />;
    }
    const requests = idValues(reports).filter((o) => o.studentIds.includes(studentId));
    if (requests.length === 0) {
      return <Alert className="mx-4"><FormattedMessage {...messages.noRequests} /></Alert>;
    }
    const style = { maxHeight: '35vh', overflowY: 'auto' };
    return (
      <ListGroup variant="flush" style={style}>
        {requests.map((item) => (
          <RequestItem
            key={item.id}
            item={item}
            types={types}
            expanded={expandedItem === item.id}
            onChange={handleChange}
            onClick={() => handleClick(item)}
          />
        ))}
      </ListGroup>
    );
  }

  if (!types || types.loading) {
    return <Spinner />;
  }
  if (webview) {
    const values = { studentIds: studentIds?.split(',').map(Number) || [] };
    return (
      <RequestForm
        onSubmit={webviewChange}
        role={role}
        types={types}
        values={values}
      />
    );
  }
  const values = { studentIds: [studentId] };
  return (
    <Card>
      <Card.Body className="d-flex align-items-baseline justify-content-between mb-3">
        <Card.Title as="h2"><FormattedMessage {...messages.header} /></Card.Title>
        { role.type === PARENT_ROLE && (
          <Button variant="primary" onClick={() => setFormValues(values)}>
            <FormattedMessage {...messages.request} />
          </Button>
        )}
      </Card.Body>
      {formValues && <RequestForm onHide={() => setFormValues(null)} onSubmit={handleChange} role={role} types={types} values={formValues} />}
      {renderRequestList()}
    </Card>
  );
}

LeaveRequests.propTypes = {
  role: PropTypes.object.isRequired,
  studentId: PropTypes.number,
  webview: PropTypes.bool,
};

export default LeaveRequests;
